import { render, staticRenderFns } from "./xixiWord.vue?vue&type=template&id=675c3517&scoped=true&"
import script from "./xixiWord.vue?vue&type=script&lang=js&"
export * from "./xixiWord.vue?vue&type=script&lang=js&"
import style0 from "./xixiWord.vue?vue&type=style&index=0&id=675c3517&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c3517",
  null
  
)

export default component.exports